<script setup lang="ts">
import { Button } from 'primevue';
import { useRafFn } from '@vueuse/core';
import { ref } from 'vue';
import { usePreviewPolygonStore } from 'shared/map/stores/previewPolygonStore';

const store = usePreviewPolygonStore();

const rotationDirection = ref<number>();
const rotationTimestamp = ref<number>();

useRafFn(({delta, timestamp}) => {
  if (rotationDirection.value !== undefined) {

    if (rotationTimestamp.value === undefined) {
      rotationTimestamp.value = timestamp;
    }

    const duration = timestamp - rotationTimestamp.value;

    if (duration > 200) {
      const modifier = Math.max(duration / 500, 1.0);
      store.rotate(rotationDirection.value * 10 * modifier * delta / 1000.0);
    }
  }
});

function beginRotate(direction: number) {
  rotationDirection.value = direction;
  rotationTimestamp.value = undefined;
  store.rotate(rotationDirection.value);
}

function stopRotate() {
  rotationDirection.value = undefined;
  rotationTimestamp.value = undefined;
}

</script>

<template>
  <div class="rotate-buttons">
    <Button icon="pi pi-replay"
      @pointerdown="beginRotate(-1)"
      @pointerup="stopRotate()"
      @pointerleave="stopRotate()"></Button>
    <Button icon="pi pi-refresh"
      @pointerdown="beginRotate(1)"
      @pointerup="stopRotate()"
      @pointerleave="stopRotate()"></Button>
  </div>
</template>

<style scoped>
  .rotate-buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: stretch;
    column-gap: 1rem;
  }

  .rotate-buttons :deep(.p-button)  {
    width: unset;
  }
</style>
